import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { RefreshCw, Beer, Heart, XCircle, Sparkles, ChevronLeft } from 'lucide-react';

const PartyTest = () => {
  const navigate = useNavigate(); 
  
  // 1. 질문지 데이터
  const questions = [
    { id: 1, type: "EI", text: "송년회 장소에 도착했다! 문을 열고 들어가면?", answers: [{ text: "오! 다들 왔어? 오늘 작정하고 놀아야지!", value: "E" }, { text: "일단 조용한 구석 자리를 스캔한다.", value: "I" }] },
    { id: 2, type: "SN", text: "건배사를 시켰다. 당신의 반응은?", answers: [{ text: "자, 올 한 해 고생 많으셨습니다! 건강을 위하여! 짠!", value: "S" }, { text: "2025년, 우리 모두 별처럼 빛나는 한 해가 되길 바라며...", value: "N" }] },
    { id: 3, type: "TF", text: "동료가 나 오늘 너무 힘들어서 술 못 마시겠어라고 한다.", answers: [{ text: "많이 안 좋아? 근처 편의점에서 약이라도 사다 줄까?", value: "T" }, { text: "헐 어떡해 ㅠㅠ 오늘 무슨 힘든 일 있었어?", value: "F" }] },
    { id: 4, type: "JP", text: "2차 노래방 가자고 한다. 당신은?", answers: [{ text: "좋지! 근데 막차 시간 확인해보고 11시쯤엔 일어나야 될 듯?", value: "J" }, { text: "무조건 콜! 오늘 밤새 달리는 거야! 가자!", value: "P" }] },
    { id: 5, type: "EI", text: "노래방에서 마이크가 내 손에 들어왔다.", answers: [{ text: "마이크는 내 운명. 첫 곡부터 분위기 띄운다.", value: "E" }, { text: "탬버린만 열심히 흔들다가, 순서 오면 최대한 짧은 곡으로...", value: "I" }] },
    { id: 6, type: "SN", text: "고기를 굽는데 불이 너무 세다.", answers: [{ text: "여기 불판 좀 갈아주세요! 탄 고기는 맛없으니까.", value: "S" }, { text: "고기가 타는 걸 보며 멍하니 불멍을 때린다.", value: "N" }] },
    { id: 7, type: "TF", text: "부장님이 아재 개그를 했다. 분위기 싸함.", answers: [{ text: "아... 부장님 그건 좀... (애써 외면하며 고기만 먹는다)", value: "T" }, { text: "푸하하! 부장님 센스 대박이신데요? (물개박수)", value: "F" }] },
    { id: 8, type: "JP", text: "내일 연차 쓸까 고민 중이다.", answers: [{ text: "내일 일정 확인해보고, 미리 연차 결재 올려놓고 맘 편히 마신다.", value: "J" }, { text: "일단 마셔! 내일의 내가 알아서 하겠지 뭐.", value: "P" }] },
    { id: 9, type: "EI", text: "옆 테이블에서 합석 제의가 왔다.", answers: [{ text: "완전 좋죠! 여기 의자 붙이세요! 사장님 여기 잔 추가요!", value: "E" }, { text: "(어색한 미소) 아, 저희끼리 조용히 먹고 싶어서요...", value: "I" }] },
    { id: 10, type: "SN", text: "맛있는 안주가 나왔다.", answers: [{ text: "오, 이 안주 식감이 특이하네. 소스랑 잘 어울린다.", value: "S" }, { text: "와, 이거 먹으니까 옛날 생각나네... 추억의 맛이다.", value: "N" }] },
    { id: 11, type: "TF", text: "누군가 술잔을 깼다!", answers: [{ text: "여기요! 유리잔 깨졌어요, 조심하세요! 빗자루 좀 부탁드려요.", value: "T" }, { text: "헉! 괜찮아? 안 다쳤어? 피 나는 거 아니야?", value: "F" }] },
    { id: 12, type: "JP", text: "회식이 끝나고 집에 가는 길.", answers: [{ text: "지금 출발하면 딱 11시 도착이네. 씻고 자면 완벽하다.", value: "J" }, { text: "이대로 가긴 좀 아쉬운데... 편의점에서 맥주 한 캔 더?", value: "P" }] }
  ];

  // 2. 결과 데이터
  const results = {
    "ISTJ": { name: "인간 계산기 총무", desc: "회비 계산 1원 단위까지 맞춤. 2차 절대 안 감.", item: "영수증", color: "bg-blue-50", emoji: "🐧" },
    "ISFJ": { name: "프로 수발러", desc: "휴지 챙겨주고 물 따라주고... 엄마처럼 다 챙겨줌.", item: "물수건", color: "bg-pink-50", emoji: "🐨" },
    "INFJ": { name: "속마음 간파하는 도사", desc: "조용히 앉아서 누가 썸타는지 다 보고 있음.", item: "수정구슬", color: "bg-purple-50", emoji: "🦉" },
    "INTJ": { name: "고독한 미식가", desc: "회식 싫어함. 안주 맛 평가하러 옴.", item: "젓가락", color: "bg-gray-100", emoji: "🦔" },
    "ISTP": { name: "영혼 없는 리액션봇", desc: "아 진짜요?만 100번 하고 집에 감.", item: "배터리 방전", color: "bg-yellow-50", emoji: "🦥" },
    "ISFP": { name: "투명인간", desc: "있었는데요, 없었습니다. (어느새 사라짐)", item: "투명망토", color: "bg-green-50", emoji: "🐢" },
    "INFP": { name: "감성 취객", desc: "술 들어가면 갑자기 인생 얘기하며 눈물 흘림.", item: "눈물", color: "bg-indigo-50", emoji: "🐰" },
    "INTP": { name: "팩트 폭격기", desc: "부장님 말에 논리적 오류 지적하다가 분위기 얼림.", item: "얼음", color: "bg-blue-100", emoji: "🦊" },
    "ESTP": { name: "술게임 조교", desc: "랜덤 게임~ 게임 스타트! 잠시도 쉬지 않음.", item: "소주병", color: "bg-red-50", emoji: "🐆" },
    "ESFP": { name: "테이블 위의 댄서", desc: "오늘만 산다. 넥타이 머리에 묶고 춤춤.", item: "미러볼", color: "bg-orange-50", emoji: "🐒" },
    "ENFP": { name: "사랑둥이 댕댕이", desc: "모든 테이블 돌아다니며 짠함. 내일 기억 못 함.", item: "하트", color: "bg-yellow-100", emoji: "🐶" },
    "ENTP": { name: "말싸움 1등", desc: "정치 얘기 꺼내서 옆자리 사람이랑 토론함.", item: "확성기", color: "bg-red-100", emoji: "🦜" },
    "ESTJ": { name: "회식 통제관", desc: "자, 잔 드시죠. 회식 진행 큐시트 머리에 있음.", item: "호루라기", color: "bg-blue-200", emoji: "🦁" },
    "ESFJ": { name: "인간 앰프", desc: "리액션 소리가 옆방까지 들림. 분위기 메이커.", item: "박수", color: "bg-pink-100", emoji: "🐬" },
    "ENFJ": { name: "평화의 수호자", desc: "싸우는 사람 말리고, 취한 사람 택시 태워 보냄.", item: "비둘기", color: "bg-green-100", emoji: "🐘" },
    "ENTJ": { name: "야망의 건배사", desc: "우리의 미래를 위하여! 회식도 업무의 연장임.", item: "사원증", color: "bg-purple-100", emoji: "🦅" },
  };

  const [step, setStep] = useState(0); 
  const [currentIdx, setCurrentIdx] = useState(0);
  const [scores, setScores] = useState({ E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 });
  const [resultMbti, setResultMbti] = useState("");

  const handleAnswer = (value) => {
    const nextScores = { ...scores, [value]: scores[value] + 1 };
    setScores(nextScores);
    if (currentIdx + 1 < questions.length) {
      setCurrentIdx(currentIdx + 1);
    } else {
      const res = [
        nextScores.E >= nextScores.I ? "E" : "I",
        nextScores.S >= nextScores.N ? "S" : "N",
        nextScores.T >= nextScores.F ? "T" : "F",
        nextScores.J >= nextScores.P ? "J" : "P"
      ].join("");
      setResultMbti(res);
      setStep(2);
    }
  };

  if (step === 0) return (
    <div className="min-h-screen bg-amber-50 flex flex-col items-center justify-center p-6 text-center">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-10 border-4 border-amber-200">
        <Beer size={80} className="mx-auto text-amber-500 mb-6 animate-bounce" />
        <h1 className="text-3xl font-black mb-2 text-gray-800">2025 송년회</h1>
        <h2 className="text-xl font-bold text-amber-600 mb-8">나의 회식 캐릭터는?</h2>
        <button onClick={() => setStep(1)} className="w-full bg-amber-500 hover:bg-amber-600 text-white font-bold py-4 rounded-2xl text-xl shadow-lg transition-all active:scale-95">테스트 시작하기</button>
      </div>
    </div>
  );

  if (step === 1) return (
    <div className="min-h-screen bg-amber-50 flex flex-col items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 border-2 border-amber-100">
        <div className="text-amber-500 font-bold mb-4">Q{currentIdx + 1} / {questions.length}</div>
        <h2 className="text-xl font-bold mb-8 text-gray-800 leading-snug">{questions[currentIdx].text}</h2>
        <div className="space-y-4">
          {questions[currentIdx].answers.map((ans, i) => (
            <button key={i} onClick={() => handleAnswer(ans.value)} className="w-full bg-gray-50 hover:bg-amber-50 border-2 border-gray-100 py-4 px-6 rounded-2xl text-left font-bold transition-all text-gray-700">
              {ans.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  if (step === 2) {
    const result = results[resultMbti] || results["ISTJ"];
    return (
      <div className={`min-h-screen ${result.color} flex flex-col items-center justify-center p-6 text-center`}>
        <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-white">
          <div className="p-10 bg-amber-500 text-white">
            <h2 className="text-3xl font-black mb-4">{result.name}</h2>
            <div className="text-8xl mb-4">{result.emoji}</div>
          </div>
          <div className="p-10">
            <p className="text-gray-700 text-lg mb-8 leading-relaxed font-medium">"{result.desc}"</p>
            <div className="bg-amber-50 p-4 rounded-xl mb-8 font-bold text-amber-800 tracking-tight">✨ 필수템: {result.item}</div>
            <button onClick={() => window.location.reload()} className="w-full py-4 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-2xl font-bold flex items-center justify-center gap-2"><RefreshCw size={20}/> 다시하기</button>
            <button onClick={() => navigate('/')} className="w-full mt-4 text-gray-400 font-bold hover:text-gray-600 transition-colors">홈으로 가기</button>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default PartyTest;
